import AccountSettingsConnector from './AccountSettingsConnector';

export default AccountSettingsConnector;
